import { VerifyCodeLinkedinMeta, VerifyCodeLinkedinPayload } from 'types/store/VerifyCodeLinkedin';
import { createAsyncAction } from 'utils/Redux';

const ns = 'VERIFY_CODE_LINKEDIN_NS';

const asyncAction = createAsyncAction<VerifyCodeLinkedinMeta, VerifyCodeLinkedinPayload>(ns);

const verifyCodeLinkedinActions = { ...asyncAction };

export default verifyCodeLinkedinActions;
